import React from 'react';
import useTwoChipRows from './useTwoChipRows.js';

// Listvy's picked searches as chips on the search band: at most two rows, the rest behind a "+N" chip
// (useTwoChipRows.js). Listvy renders the search twice (phone row and desktop header), so each copy measures
// its own.
const ListViewSearchChips = ({ suggestions, swedish, onRemove, onClearAll }) => {
    const chipRows = useTwoChipRows(suggestions.length, suggestions.map((suggestion) => (
        `${suggestion.label}:${suggestion.excludedRegsoIds?.length || 0}`
    )).join('|'));
    if (!suggestions.length) return null;
    return (
        <div ref={chipRows.ref} className="list-view-search-selected">
            {suggestions.map((suggestion, index) => (
                <span
                    key={`selected-${suggestion.id}`}
                    className="list-view-search-chip"
                    data-chip=""
                    hidden={index >= chipRows.visibleCount}
                >
                    <span className="list-view-search-chip-label">{suggestion.label}</span>
                    {Array.isArray(suggestion.excludedRegsoIds) && suggestion.excludedRegsoIds.length > 0 && (
                        <span
                            className="list-view-search-chip-meta"
                            title={swedish
                                ? `${suggestion.excludedRegsoIds.length} områden bortvalda på kartan`
                                : `${suggestion.excludedRegsoIds.length} areas deselected on the map`}
                        >
                            −{suggestion.excludedRegsoIds.length}
                        </span>
                    )}
                    <button
                        type="button"
                        className="list-view-search-chip-remove"
                        onClick={() => onRemove(suggestion.id)}
                        aria-label={swedish ? `Ta bort ${suggestion.label}` : `Remove ${suggestion.label}`}
                    >
                        ×
                    </button>
                </span>
            ))}
            <button
                type="button"
                className="list-view-search-more"
                data-chip-toggle=""
                hidden={!chipRows.hasMore}
                onClick={() => chipRows.setExpanded((value) => !value)}
                aria-expanded={chipRows.expanded}
                aria-label={chipRows.expanded
                    ? (swedish ? 'Visa färre' : 'Show fewer')
                    : (swedish ? `Visa ${chipRows.hiddenCount} till` : `Show ${chipRows.hiddenCount} more`)}
            >
                {chipRows.expanded ? (swedish ? 'Visa färre' : 'Show fewer') : `+${chipRows.hiddenCount}`}
            </button>
            {onClearAll && (
                <button type="button" className="list-view-search-clear-all" onClick={() => onClearAll()}>
                    {swedish ? 'Rensa' : 'Clear'}
                </button>
            )}
        </div>
    );
};

export default ListViewSearchChips;
